import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_coupon_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  softpin: fromDatatype.VarcharDatatypeInterface;
  assignment_date: fromDatatype.TimestampTzDatatypeInterface;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  source: fromDatatype.VarcharDatatypeInterface;
  activation_pin: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  merchant_guid: fromDatatype.GuidDataFieldInterface;
  activation_status: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  serial_no_barcode: fromDatatype.TextDatatypeInterface;
  voucher_code_barcode: fromDatatype.TextDatatypeInterface;
  assigned_to: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_coupon_line_RowClass
  implements bl_fi_mst_coupon_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: any;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: any;
  pricing_bundle_json: any;
  payment_logic_json: any;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  softpin: fromDatatype.VarcharDatatypeInterface;
  assignment_date: fromDatatype.TimestampTzDatatypeInterface;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  source: fromDatatype.VarcharDatatypeInterface;
  activation_pin: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  merchant_guid: fromDatatype.GuidDataFieldInterface;
  activation_status: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  serial_no_barcode: fromDatatype.TextDatatypeInterface;
  voucher_code_barcode: fromDatatype.TextDatatypeInterface;
  assigned_to: fromDatatype.GuidDataFieldInterface;
}
